export const BARCODE_MAX_LENGTH = 32;

export const BARCODE_PATTERN = /^[A-Z0-9\-/.]+$/;

export const BARCODE_HELPER_TEXT =
  "e.g. ABH/18212-01 — letters, digits, dash, slash, dot; max 32 chars";

export const normalizeBarcode = (value) =>
  typeof value === "string" ? value.trim().toUpperCase() : value;

const SERVER_ERROR_RULES = [
  {
    match: (msg) => msg === "Missing barcode. Every product must have one.",
    message: "Barcode is required.",
  },
  {
    match: (msg) => msg.startsWith("Invalid barcode format"),
    message:
      "Invalid barcode format. Use letters, digits, dash, slash, or dot only.",
  },
  {
    match: (msg) =>
      msg === "Barcode exceeds max length 32" ||
      msg.startsWith("Barcode exceeds max length"),
    message: `Barcode cannot exceed ${BARCODE_MAX_LENGTH} characters.`,
  },
  {
    match: (msg) => msg === "Barcode already exists on another product",
    message: "This barcode is already in use by another product.",
  },
];

export const mapBarcodeServerError = (rawMessage) => {
  if (typeof rawMessage !== "string" || !rawMessage) return null;
  const rule = SERVER_ERROR_RULES.find((r) => r.match(rawMessage));
  return rule ? rule.message : null;
};

export class BarcodeFieldError extends Error {
  constructor(fieldMessage) {
    super(fieldMessage);
    this.name = "BarcodeFieldError";
    this.fieldMessage = fieldMessage;
  }
}

export const extractBarcodeServerMessage = (err) => {
  const raw =
    err?.response?.data?.response?.message ||
    err?.response?.data?.message ||
    null;
  return mapBarcodeServerError(raw);
};
